import OfficeTicketDetailLayout from './OfficeTicketDetailLayout';

export default OfficeTicketDetailLayout;
